var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWaveBottomJaune(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "visual",
    viewBox: "0 0 1600 300",
    width: 1600,
    height: 300,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 99L88.8 110.7C177.7 122.3 355.3 145.7 533.2 158.3C711 171 889 173 1066.8 162.3C1244.7 151.7 1422.3 128.3 1511.2 116.7L1600 105L1600 0L1511.2 0C1422.3 0 1244.7 0 1066.8 0C889 0 711 0 533.2 0C355.3 0 177.7 0 88.8 0L0 0Z",
    fill: "#ffcc00",
    strokeLinecap: "round",
    strokeLinejoin: "miter"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaveBottomJaune);
export default __webpack_public_path__ + "static/media/wave-bottom-jaune.7189473d791bad67feaecd4ed84a1268.svg";
export { ForwardRef as ReactComponent };